import React from 'react';
import { map } from 'lodash';
import classnames from 'classnames';

// local dependencies
import { WIDGET_NAMES } from 'constants/entity-names';
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { CallStatisticsReports } from 'ui/containers/CallStatisticsReports';

// import { callStatisticsReportsPreloader as CallStatisticsReportsPreloader } from 'ui/views/widgets/callStatisticsReports';
import { CallResolutionReporting } from 'ui/containers/CallResolutionReporting';
import { widgetPreloader as WidgetPreloader } from 'ui/views/generic/widgetPreloader';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { statisticsReports as StatisticsReports } from 'ui/views/widgets/statisticsReports';
 *
 * // render
 * <StatisticsReports propName='propValue'/>
 */

 // widget views
const WIDGET_VIEWS = {
    [ WIDGET_NAMES.CALL_STATISTICS_REPORTS ]: CallStatisticsReports,
    [ WIDGET_NAMES.CALL_RESOLUTIONS_REPORTS ]: CallResolutionReporting
};

const statisticsReportsSuccess = ( props ) => {
    return (
        <div className='ui-statistics-reports'>
            {
                map( props.widgets, widget => {

                    // get widget view
                    const WidgetView = WIDGET_VIEWS[ widget.name ];
        
                    // widget class name
                    const widgetClassName = classnames( 'ui-statistics-reports__widget', `ui-statistics-reports__widget--name-${ widget.name }` );
        
                    return (
                        <div key={ widget.name } className={ widgetClassName }>
                            <WidgetView widget={ widget } />
                        </div>
                    );
                } )
            }
        </div>
    );
};

// set display name
statisticsReportsSuccess.displayName = 'statisticsReportsSuccess';

// set default props
statisticsReportsSuccess.defaultProps = {};

// prop types
statisticsReportsSuccess.propTypes = {};


export const statisticsReportsPreloader = () => {
    return (
        <div className='ui-statistics-reports-preloader'>
            <WidgetPreloader />
        </div>
    );
};

// set display name
statisticsReportsPreloader.displayName = 'statisticsReportsPreloader';

// set default props
statisticsReportsPreloader.defaultProps = {};

// prop types
statisticsReportsPreloader.propTypes = {};

/************************************************************** */

export const statisticsReports = withNetworkState( statisticsReportsPreloader, statisticsReportsSuccess );
